(() => {
  'use strict';

  const aliases = {
    be: 'be',
    belgium: 'be',
    belgie: 'be',
    'belgië': 'be',
    nl: 'nl',
    netherlands: 'nl',
    nederland: 'nl'
  };

  const getEventKey = () => {
    const value = new URL(window.location.href).searchParams.get('event');
    return value ? aliases[value.trim().toLowerCase()] || '' : '';
  };

  const getUtmData = () => {
    const params = new URL(window.location.href).searchParams;
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || ''
    };
  };

  const pushEvent = (eventName, eventKey, country, linkLocation) => {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (
      !customerPrivacy ||
      typeof customerPrivacy.analyticsProcessingAllowed !== 'function' ||
      !customerPrivacy.analyticsProcessingAllowed()
    ) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      event_key: eventKey || '',
      event_country: country || '',
      link_location: linkLocation || '',
      ...getUtmData()
    });
  };

  const setEventInUrl = (eventKey, mode = 'push', hash = '') => {
    const url = new URL(window.location.href);
    if (eventKey) {
      url.searchParams.set('event', eventKey);
      url.hash = hash;
    } else {
      url.searchParams.delete('event');
      url.hash = '';
    }
    window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', url);
  };

  const getFormAvailability = () => {
    const availability = { be: false, nl: false };
    document.querySelectorAll('[data-alpha-q-form-status]').forEach((marker) => {
      const eventKey = marker.dataset.eventKey;
      if (eventKey in availability) {
        availability[eventKey] = marker.dataset.formAvailable === 'true';
      }
    });
    return availability;
  };

  const initializeCampaign = (root) => {
    if (root.dataset.alphaQInitialized === 'true') return;

    const dataNode = root.querySelector('[data-alpha-q-data]');
    if (!dataNode) return;

    let eventData;
    try {
      eventData = JSON.parse(dataNode.textContent);
    } catch (_error) {
      return;
    }

    root.dataset.alphaQInitialized = 'true';
    root.classList.add('alpha-q--enhanced');

    const isDesignMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    const emptyStates = Array.from(root.querySelectorAll('[data-alpha-q-empty]'));
    const primaryEmptyState = emptyStates[0] || null;
    const selectedState = root.querySelector('[data-alpha-q-selected]');
    const selectedHeading = root.querySelector('[data-alpha-q-selected-heading]');
    const status = root.querySelector('[data-alpha-q-status]');
    const selectors = Array.from(root.querySelectorAll('[data-alpha-q-select]'));
    let selectedEvent = '';

    const updateText = (selector, value) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.textContent = value || '';
      });
    };

    const syncRegistrationLinks = (eventKey) => {
      const forms = getFormAvailability();
      document.querySelectorAll('[data-alpha-q-registration-link]').forEach((link) => {
        const eventPanel = link.closest('[data-alpha-q-panel]');
        const fixedKey = eventPanel ? eventPanel.dataset.alphaQPanel : '';
        const linkKey = fixedKey || eventKey;
        link.dataset.eventKey = linkKey || '';
        link.href = '#aanmelden';
        link.hidden = !linkKey || !forms[linkKey];
      });
    };

    const updateCampaign = (eventKey, announce = false) => {
      selectedEvent = eventData[eventKey] ? eventKey : '';
      const selected = selectedEvent ? eventData[selectedEvent] : null;

      root.dataset.selectedEvent = selectedEvent;
      if (selectedEvent) {
        document.documentElement.setAttribute('data-alpha-q-event', selectedEvent);
      } else {
        document.documentElement.removeAttribute('data-alpha-q-event');
      }
      emptyStates.forEach((emptyState) => {
        emptyState.hidden = isDesignMode ? false : Boolean(selected);
      });
      if (selectedState) selectedState.hidden = !selected;

      selectors.forEach((selector) => {
        const isActive = selector.dataset.alphaQSelect === selectedEvent;
        selector.classList.toggle('is-active', isActive);
        if (isActive) {
          selector.setAttribute('aria-current', 'true');
        } else {
          selector.removeAttribute('aria-current');
        }
      });

      root.querySelectorAll('[data-alpha-q-panel]').forEach((panel) => {
        panel.hidden = isDesignMode ? false : !selected || panel.dataset.alphaQPanel !== selectedEvent;
      });

      document.querySelectorAll('[data-alpha-q-registration]').forEach((registration) => {
        registration.hidden = isDesignMode ? false : !selected || registration.dataset.alphaQRegistration !== selectedEvent;
      });

      document.querySelectorAll('[data-alpha-q-faq-event]').forEach((faq) => {
        const faqEvent = faq.dataset.alphaQFaqEvent;
        faq.hidden = isDesignMode ? false : faqEvent !== 'all' && faqEvent !== selectedEvent;
      });

      document.querySelectorAll('[data-alpha-q-final]').forEach((finalCta) => {
        finalCta.hidden = !selected;
      });

      if (selected) {
        root.querySelectorAll('[data-alpha-q-output]').forEach((element) => {
          element.textContent = selected[element.dataset.alphaQOutput] || '';
        });
        updateText('[data-alpha-q-final-output="date"]', selected.date);
        updateText('[data-alpha-q-final-output="location"]', selected.location);

        root.querySelectorAll('[data-alpha-q-programme-link]').forEach((link) => {
          link.href = `#${selected.programme}`;
          link.dataset.eventKey = selectedEvent;
        });
      } else {
        updateText('[data-alpha-q-final-output="date"]', '');
        updateText('[data-alpha-q-final-output="location"]', '');
      }

      syncRegistrationLinks(selectedEvent);

      if (announce && status) {
        status.textContent = selected
          ? `${selected.country} is geselecteerd. Datum, locatie en programma zijn bijgewerkt.`
          : 'Kies België of Nederland om de datum, locatie en het programma te bekijken.';
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-alpha-q-track]');
      if (!link) return;

      const eventKey = link.dataset.eventKey || selectedEvent;
      const selected = eventData[eventKey];
      pushEvent(
        link.dataset.alphaQTrack,
        eventKey,
        selected ? selected.country : '',
        link.dataset.linkLocation || ''
      );
    }, { capture: true });

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getHeaderOffset = () => {
      const raw = parseFloat(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      );
      const cssHeight = Number.isFinite(raw) ? raw : 0;
      const header = document.querySelector('#shopify-section-header-inline, .mz-section-header');
      const renderedHeight = header ? header.getBoundingClientRect().height : 0;
      return Math.max(cssHeight, renderedHeight, 64) + 18;
    };

    const getHashTarget = (hash) => {
      if (!hash || hash === '#') return null;
      try {
        return document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (_error) {
        return null;
      }
    };

    const focusTarget = (target) => {
      const heading = target.matches('h1,h2,h3') ? target : target.querySelector('h1,h2,h3');
      if (!heading) return;
      const hadTabindex = heading.hasAttribute('tabindex');
      if (!hadTabindex) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      if (!hadTabindex) {
        heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
      }
    };

    const scrollToTarget = (target, { hash = '', updateHistory = true, behavior = '' } = {}) => {
      if (!target || target.hidden || target.closest('[hidden]')) return;

      if (updateHistory && hash) {
        const next = new URL(window.location.href);
        next.hash = hash;
        const x = window.scrollX;
        const y = window.scrollY;
        const method = next.href === window.location.href ? 'replaceState' : 'pushState';
        window.history[method](window.history.state, '', next);
        window.scrollTo(x, y);
      }

      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - getHeaderOffset());
      const chosenBehavior = behavior || (reduceMotion() ? 'auto' : 'smooth');
      if (chosenBehavior === 'smooth') {
        const start = window.scrollY;
        const distance = top - start;
        const duration = Math.min(760, Math.max(420, Math.abs(distance) * 0.18));
        const startedAt = window.performance.now();
        const easeInOutCubic = (progress) => (
          progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2
        );
        const animate = (now) => {
          const progress = Math.min(1, (now - startedAt) / duration);
          window.scrollTo(0, start + distance * easeInOutCubic(progress));
          if (progress < 1) window.requestAnimationFrame(animate);
        };
        window.requestAnimationFrame(animate);
      } else {
        window.scrollTo(0, top);
      }
      const focusDelay = chosenBehavior === 'smooth' ? 780 : 0;
      window.setTimeout(() => focusTarget(target), focusDelay);
    };

    const scrollToRegistration = (eventKey, updateHistory = true, behavior = '') => {
      const registration = document.querySelector(`[data-alpha-q-registration="${eventKey}"]`);
      if (!registration) return;

      if (selectedEvent !== eventKey) {
        updateCampaign(eventKey, false);
      }
      if (registration.hidden) return;

      scrollToTarget(registration, { hash: '#aanmelden', updateHistory, behavior });
    };

    selectors.forEach((selector) => {
      selector.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const eventKey = selector.dataset.alphaQSelect;
        const selected = eventData[eventKey];
        if (!selected) return;

        const goesToRegistration = selector.dataset.alphaQSelectDestination === 'registration';
        pushEvent('alpha_q_event_select', eventKey, selected.country, selector.dataset.linkLocation || 'event_selector');
        setEventInUrl(eventKey, 'push', goesToRegistration ? '#aanmelden' : '');
        updateCampaign(eventKey, true);

        if (goesToRegistration) {
          window.requestAnimationFrame(() => scrollToRegistration(eventKey, false));
        } else if (selectedHeading) {
          selectedHeading.focus({ preventScroll: true });
        }
      });
    });

    root.querySelectorAll('[data-alpha-q-clear]').forEach((button) => {
      button.addEventListener('click', () => {
        setEventInUrl('');
        updateCampaign('', true);
        if (primaryEmptyState) primaryEmptyState.focus({ preventScroll: true });
      });
    });

    document.querySelectorAll('[data-alpha-q-registration-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const eventKey = link.dataset.eventKey || selectedEvent;
        if (!eventKey) return;
        event.preventDefault();
        scrollToRegistration(eventKey, true);
      });
    });

    root.querySelectorAll('[data-alpha-q-programme-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) return;
        const target = getHashTarget(url.hash);
        if (!target) return;
        event.preventDefault();
        const targetHash = url.hash;
        scrollToTarget(target, { updateHistory: false });
        window.setTimeout(() => {
          const next = new URL(window.location.href);
          next.hash = targetHash;
          window.history.pushState(window.history.state, '', next);
        }, reduceMotion() ? 0 : 780);
      });
    });

    root.querySelectorAll('[data-alpha-q-programme-link]').forEach((link) => {
      link.addEventListener('focus', () => {
        if (link.dataset.alphaQPointerFocus === 'true') return;
        link.scrollIntoView({ block: 'nearest' });
      });
      link.addEventListener('pointerdown', () => {
        link.dataset.alphaQPointerFocus = 'true';
      });
      link.addEventListener('pointerup', () => {
        window.setTimeout(() => delete link.dataset.alphaQPointerFocus, 0);
      });
    });

    window.addEventListener('popstate', () => {
      updateCampaign(getEventKey(), false);
      const hash = window.location.hash;
      if (!hash) return;
      window.requestAnimationFrame(() => {
        if (hash === '#aanmelden' && getEventKey()) {
          scrollToRegistration(getEventKey(), false, 'auto');
        } else {
          scrollToTarget(getHashTarget(hash), { updateHistory: false, behavior: 'auto' });
        }
      });
    });

    const initialEvent = getEventKey();
    updateCampaign(initialEvent, false);

    const rawEvent = new URL(window.location.href).searchParams.get('event');
    if (initialEvent && rawEvent !== initialEvent) {
      setEventInUrl(initialEvent, 'replace');
    }

    if (window.location.hash) {
      window.requestAnimationFrame(() => {
        if (window.location.hash === '#aanmelden' && initialEvent) {
          scrollToRegistration(initialEvent, false, 'auto');
        } else {
          scrollToTarget(getHashTarget(window.location.hash), { updateHistory: false, behavior: 'auto' });
        }
      });
    }

    root.alphaQRefresh = () => updateCampaign(selectedEvent || getEventKey(), false);
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-alpha-q]').forEach(initializeCampaign);
    document.querySelectorAll('[data-alpha-q]').forEach((root) => {
      if (typeof root.alphaQRefresh === 'function') root.alphaQRefresh();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
